import React, { useState, useMemo } from 'react';
import ResponsiveTable from './ResponsiveTable';
import MultiSelectListBox from './MultiSelectListBox'
import Container from 'react-bootstrap/Container';
import Header from './Header';

const HomePage = ({ data = [], privileges = [] }) => {
	const header_sh1 = Object.keys(data.sheet1[0]).filter(value => privileges.includes(value))
	const header_sh2 = Object.keys(data.sheet2[0])

	const AmbitoOptions = Array.from(new Set(data.sheet1.map(item => item.Ambito)));
	const ambitoOptsMap = AmbitoOptions.map(s => ({label: s, value: s.toLowerCase()}))

	const [colturaOptsMap, setColturaOptsMap] = useState([]);
	const [ambitoFilter, setAmbitoFilter] = useState([]);
	const handleFilterFromAmbito = (filter) => {
		setAmbitoFilter(filter);
		const newAmbitoFilteredData = data.sheet1.filter(item => filter.some(filter => filter.label === item.Ambito));
		const newOptions = Array.from(new Set(newAmbitoFilteredData.map(item => item.coltura)));
		setColturaOptsMap(newOptions.map(s => ({label: s, value: s.toLowerCase()})))
		handleFilterFromColtura([])
		handleFilterFromServizio([])
		handleFilterFromSensore([])
		handleFilterFromGrandezza([])
	};
	
	const [servizioOptsMap, setServizioOptsMap] = useState([]);
	const [colturaFilter, setColturaFilter] = useState([]);
	const handleFilterFromColtura = (filter) => {
		setColturaFilter(filter);
		const newColturaFilteredData = data.sheet1.filter(item => filter.some(filter => filter.label === item.coltura));
		const newOptions = Array.from(new Set(newColturaFilteredData.map(item => item.Servizio)));		
		setServizioOptsMap(newOptions.map(s => ({label: s, value: s.toLowerCase()})))
		handleFilterFromServizio([])
		handleFilterFromSensore([])
		handleFilterFromGrandezza([])
	};
	
	const [sensoreOptsMap, setSensoreOptsMap] = useState([]);
	const [servizioFilter, setServizioFilter] = useState([]);
	const handleFilterFromServizio = (filter) => {
		setServizioFilter(filter);
		const newServizioFilteredData = data.sheet1.filter(item => filter.some(filter => filter.label === item.Servizio));
		const newOptions = Array.from(new Set(newServizioFilteredData.map(item => item.Sensore)));
		setSensoreOptsMap(newOptions.map(s => ({label: s, value: s.toLowerCase()})))
		handleFilterFromSensore([])
		handleFilterFromGrandezza([])
	};
	
	const [grandezzaOptsMap, setGrandezzaOptsMap] = useState([]);
	const [sensoreFilter, setSensoreFilter] = useState([]);
	const handleFilterFromSensore = (filter) => {
		setSensoreFilter(filter);
		let newSensoreFilteredData =  data.sheet2.filter(item => ambitoFilter.some(ambitoFilter => ambitoFilter.label === item.Ambito));
		newSensoreFilteredData =  newSensoreFilteredData.filter(item => servizioFilter.some(servizioFilter => servizioFilter.label === item.Servizio));
		newSensoreFilteredData = newSensoreFilteredData.filter(item => filter.some(filter => filter.label === item.Sensore));
		const newOptions = Array.from(new Set(newSensoreFilteredData.map(item => item['Grandezza Fisico/Chimica'])));
		setGrandezzaOptsMap(newOptions.map(s => ({label: s, value: s.toLowerCase()})))
		handleFilterFromGrandezza([])
		setActiveDataSet('sheet1');
	};
	
	const [grandezzaFilter, setGrandezzaFilter] = useState([]);
	const handleFilterFromGrandezza = (filter) => {
		setGrandezzaFilter(filter);
		setActiveDataSet(filter?.length > 0 ? 'sheet2' : 'sheet1');
	};
	
	const [activeDataSet, setActiveDataSet] = useState('sheet1'); // 'data1' or 'data2'
	const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
	const sortedData = useMemo(() => {
		let dataToSort = activeDataSet === 'sheet1' ? [...data.sheet1] : [...data.sheet2];

		if (sortConfig.key !== null) {
			dataToSort.sort((a, b) => {
				
				let aValue = "" + (a[sortConfig.key] || "");
				let bValue = "" + (b[sortConfig.key] || "");
				
				aValue = aValue.toLowerCase();
				bValue = bValue.toLowerCase();
				
				if (aValue < bValue) {
					return sortConfig.direction === 'ascending' ? -1 : 1;
				}
				if (aValue > bValue) {
					return sortConfig.direction === 'ascending' ? 1 : -1;
				}
			return 0;
		});
		}

		return dataToSort;
	}, [data.sheet1, data.sheet2, activeDataSet, sortConfig]);
	
	const requestSort = (key) => {
		let direction = 'ascending';
		if (sortConfig.key === key && sortConfig.direction === 'ascending') {
			direction = 'descending';
		}
		setSortConfig({ key, direction });
	};

	const fullHeightStyle = {
        minHeight: '100vh'
    };
	
	return(
		<Container fluid style={fullHeightStyle}>
			<Header />
			<h3 style={{ textAlign: 'center', color:'#233D62'}}>Ambito</h3>
			<MultiSelectListBox selected={ambitoFilter} onSelectionChange={handleFilterFromAmbito} options={ambitoOptsMap}/>
			<h3 style={{ textAlign: 'center', color:'#233D62'}}>Coltura</h3>
			<MultiSelectListBox selected={colturaFilter} onSelectionChange={handleFilterFromColtura} options={colturaOptsMap} disable={ambitoFilter.length === 0}/>
			<h3 style={{ textAlign: 'center', color:'#233D62'}}>Servizio</h3>
			<MultiSelectListBox selected={servizioFilter} onSelectionChange={handleFilterFromServizio} options={servizioOptsMap} disable={colturaFilter.length === 0}/>
			<h3 style={{ textAlign: 'center', color:'#233D62'}}>Sensore</h3>
			<MultiSelectListBox selected={sensoreFilter} onSelectionChange={handleFilterFromSensore} options={sensoreOptsMap} disable={servizioFilter.length === 0}/>
			<h3 style={{ textAlign: 'center', color:'#233D62'}}>Grandezza</h3>
			<MultiSelectListBox selected={grandezzaFilter} onSelectionChange={handleFilterFromGrandezza} options={grandezzaOptsMap} disable={sensoreFilter.length === 0}/>
			<ResponsiveTable 
				headers = {grandezzaFilter.length === 0 ? header_sh1 : header_sh2}
				data={sortedData} 
				ambitoFilter={ambitoFilter} 
				colturaFilter={colturaFilter} 
				sensoreFilter={sensoreFilter} 
				servizioFilter={servizioFilter}
				grandezzaFilter={grandezzaFilter}
				onSort={requestSort} 
				sortConfig={sortConfig}/>
		</Container>
	)
}

export default HomePage;